import styled from "styled-components"

const Online = () => {
    return (
        <Wrapper>online</Wrapper>
    )
}

const Wrapper = styled.p`
    color:green ;
`

export default Online